export const SUCCESS_GET_ALLCLIENTRAS = 'SUCCESS_GET_ALLCLIENTRAS';
export const FAILED_GET_ALLCLIENTRAS = 'FAILED_GET_ALLCLIENTRAS';
export const SUCCESS_CREATE_CLIENTRAS = 'SUCCESS_CREATE_CLIENTRAS';
export const FAILED_CREATE_CLIENTRAS = 'FAILED_CREATE_CLIENTRAS';
export const SUCCESS_UPDATE_CLIENTRAS = 'SUCCESS_UPDATE_CLIENTRAS';
export const FAILED_UPDATE_CLIENTRAS = 'FAILED_UPDATE_CLIENTRAS';
export const SUCCESS_DELETE_CLIENTRAS = 'SUCCESS_DELETE_CLIENTRAS';
export const FAILED_DELETE_CLIENTRAS = 'FAILED_DELETE_CLIENTRAS';
export const SUCCESS_GET_CLIENTRAS = 'SUCCESS_GET_CLIENTRAS';
export const FAILED_GET_CLIENTRAS = 'FAILED_GET_CLIENTRAS';


// WEBPACK FOOTER //
// src/state/constants/clientRasConstants.js